import { DataCollectionGraphActionTypes } from '../constants/ApiConstants';


const initialState = {
  loading: false,
  DCPatientSkillAcqGraphData: null,
  DCPatientBehaviourGraphData: null,
  AnnotationLabel: [],
  BaselineLabel: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case DataCollectionGraphActionTypes.get_DC_PatientSkillAcqGraphAPI.REQUEST:
      return {
        ...state,
        loading: true,
        DCPatientSkillAcqGraphData: null,
      };
    case DataCollectionGraphActionTypes.get_DC_PatientSkillAcqGraphAPI.SUCCESS:
      return {
        ...state,
        loading: false,
        DCPatientSkillAcqGraphData: payload,
      };
    case DataCollectionGraphActionTypes.get_DC_PatientBehaviourGraphAPI.REQUEST:
      return {
        ...state,
        loading: true,
        DCPatientBehaviourGraphData: null,
      };
    case DataCollectionGraphActionTypes.get_DC_PatientBehaviourGraphAPI.SUCCESS:
      return {
        ...state,
        loading: false,
        DCPatientBehaviourGraphData: payload,
      };
      case DataCollectionGraphActionTypes.get_TargetsAndProgramsData.REQUEST:
      return {
        ...state,
        loading: true,
        targetsAndProgramsData: null,
      };
    case DataCollectionGraphActionTypes.get_TargetsAndProgramsData.SUCCESS:
      return {
        ...state,
        loading: false,
        targetsAndProgramsData: payload,
      };
    case DataCollectionGraphActionTypes.get_BehaviorsReductionsData.REQUEST:
      return {
        ...state,
        loading: true,
        behaviorsReductionsData: null,
      };
    case DataCollectionGraphActionTypes.get_BehaviorsReductionsData.SUCCESS:
      return {
        ...state,
        loading: false,
        behaviorsReductionsData: payload,
      };
    case DataCollectionGraphActionTypes.set_GraphAnnotationAndBaselineBlank.SUCCESS:
        return {
          ...state,
          loading: false,
          AnnotationLabel: [],
          BaselineLabel: [],
        };
    case DataCollectionGraphActionTypes.set_GraphAnnotationValue.REQUEST:
          return {
            ...state,
            loading: false,
            AnnotationLabel: [],
          };
    case DataCollectionGraphActionTypes.set_GraphAnnotationValue.SUCCESS:
        return {
          ...state,
          loading: false,
          AnnotationLabel: payload,
        };
    case DataCollectionGraphActionTypes.set_GraphBaselineValue.REQUEST:
        return {
          ...state,
          loading: false,
          BaselineLabel: [],
        };
    case DataCollectionGraphActionTypes.set_GraphBaselineValue.SUCCESS:        
        return {
          ...state,
          loading: false,
          BaselineLabel: payload,
        };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollectionGraph/reducers/index.js